<template>
    <v-col class="register default-slot" md="7" sm="12">
      <div class="top-icons">
        <router-link class="back-icon" to="/">
          <font-awesome-icon icon="long-arrow-alt-left" size="lg"/> Back to home
        </router-link>
      </div>
      <h1 class="register-title mb-3">Puppy/Dog Owner(s) Information</h1>
      <v-alert type="warning" class="my-3" v-if="registerMember || renewMember">
        <p v-if="registerMember">
          You need to become a member in order to register a dog, you can register <router-link to="/registration/member">here  to proceed with registration.</router-link>.
        </p>
        <p v-else>You're not an active member at the moment please renew <router-link to="/renew/member">here</router-link> to proceed with registration.</p>
      </v-alert>
      <v-alert type="warning" class="my-3">
        Note: By default litter owners are added as owners of the puppy/registered dog. You can add or remove people from the owners list by clicking "ADD OR REMOVE OWNER(S)" button.
      </v-alert>
      <v-row>
        <v-col>
          <EditableCoOwnersList 
            :owners="dogOwners" 
            :ownershipType="dogOwnershipType"
            v-on:selectedOwnersChanged="updateSelectedCoownersFn($event.newPeople)"
            :searchCoownersFn="searchCoownersFn"
          />
        </v-col>
      </v-row>
      <div class="mt-10 mr-5">
        <p class="signature-terms">
          Upon signing, I testify that all data submitted is correct.
          I understand that all applications become the property of ASCA.
          If an application has been falsified, no registration certificate will be issued and fees will not be refunded.
          I hereby certify that this dog has not been registered as another breed.
          In addition, I will not register this dog as another breed.
          I understand if I register this dog as another breed its ASCA registration will be revoked.
          Should information in this application prove false, applicant will indemnify and defend ASCA and hold it harmless against any resulting loss.
          The lineage of your dog can be determined, with certainty, by DNA testing sponsored by ASCA.
          I further understand that as owner of an ASCA registered dog, I agree to abide by the <ASCAArtIncLink />, <BylawsLink />, rules of the ASCA Registries and all event programs, and to disciplinary action, if necessary, as determined by the Board of Directors of ASCA.
        </p>
        <div class="agreement-container">
          <div class="agreement-input-container">
              <div class="agreement-input">
                  <p>X</p>
                  <v-text-field
                    flat
                    solo
                    label="Owner's Digital Signature Here"
                    type="text"
                    v-model="signatureText"
                    hide-details="auto"
                  />
              </div>
              <p class="agreement-date">{{$dateUtils.formatLongDate(agreementDate)}}</p>
          </div>
      </div>
      </div>
      <v-btn
        class="white--text"
        large
        color="primary"
        :dark="isValid()"
        :disabled="!isValid()"
        v-on:click="() => {updateSignatureFn(signatureText);changePage(2);}"
      >NEXT</v-btn>
      <p class="steps">STEP <b>1</b> OF <b>3</b></p>
      <footer-text />
    </v-col>
  </template>

  <script lang="ts">
  import Vue from "vue";
  import { UserInfo } from "@/types/User";
  import EditableCoOwnersList from "@/components/Portal/EditableCoOwnersList.vue";
  import FooterText from "@/components/common/FooterText.vue";
  import ASCAArtIncLink from "@/components/common/ASCAArtIncLink.vue";
  import BylawsLink from "@/components/common/BylawsLink.vue";
  import { OwnershipType } from "@/components/common/CoownersList.vue";

  export default Vue.extend({
    name: "OwnerInformation",
    components: { FooterText, EditableCoOwnersList, ASCAArtIncLink, BylawsLink },
    props: {
      changePage: Function,
      registerMember: Boolean,
      renewMember: Boolean,
      signature: String,
      dogOwners: Array,
      updateSelectedCoownersFn: Function,
      searchCoownersFn: Function,
      updateSignatureFn: Function,
    },
    data: function () {
      return {
        agreementDate: new Date(),
        coOwnerDialog: false,
        selectedCoowners: this.dogOwners as any[],
        signatureText: this.$props.signature,
      }
    },
    computed: {
      userInfo(): UserInfo {
        return this.$store.state.userInfo;
      },
      dogOwnershipType: function() {
        return OwnershipType.Dog;
      },
    },
    methods: {
      toggleCoOwnerModal: function () {
        this.$data.coOwnerDialog = !this.$data.coOwnerDialog;
      },
      isValid() {
        return !this.registerMember && !this.renewMember && !!this.signatureText && this.dogOwners.length > 0;// && this.dogOwners.some(own => own.isPrimary);
      },
      addComma(targetValue: string | null, afterValue: string | null) {
        if (!targetValue) return '';
        else if (!!afterValue) return `${targetValue},`;
        else return targetValue;
      },
      updateSelectedCoowners: function (val: any) {
        this.selectedCoowners = val.newPeople;
      },
    }
  });
  </script>